var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.39961 10.4001L4.96611 8.00013L6.79933 9.71439L10.8324 5.94302M8.08853 5.6001H11.1996V8.50929M3.19961 14.4001C2.31595 14.4001 1.59961 13.6838 1.59961 12.8001V3.2001C1.59961 2.31644 2.31595 1.6001 3.19961 1.6001H12.7996C13.6833 1.6001 14.3996 2.31644 14.3996 3.2001V12.8001C14.3996 13.6838 13.6833 14.4001 12.7996 14.4001H3.19961Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnalytics);
export default __webpack_public_path__ + "static/media/ic-analytics.aff9132c8bb01f8522d5308b69320b22.svg";
export { ForwardRef as ReactComponent };